import type { CreateInventoryData, InventorySummary } from '../services/inventoryService';

/** Add-inventory form allows empty quantity fields while typing; API still uses numbers only. */
export type InventoryFormData = Omit<CreateInventoryData, 'casesAvailable' | 'unitsAvailable'> & {
  casesAvailable: number | '';
  unitsAvailable: number | '';
};

export function getEmptyAddInventoryForm(): InventoryFormData {
  return {
    productId: 0,
    casesAvailable: '',
    unitsAvailable: '',
    productionDate: new Date().toISOString().split('T')[0],
    expiryDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    batchNumber: '',
    notes: '',
  };
}

/** Parses MUI number input value; empty string stays empty (avoids coercing to 0). */
export function parseInventoryQuantityInput(raw: string): number | '' {
  if (raw === '') return '';
  return Number(raw);
}

export const getStockStatusColor = (summary?: InventorySummary) => {
  if (!summary) return 'default';
  if (summary.availableCases === 0) return 'error';
  if (summary.belowMinimum) return 'error';
  if (summary.belowThreshold) return 'warning';
  return 'success';
};

export const getStockStatusLabel = (summary?: InventorySummary) => {
  if (!summary) return 'UNKNOWN';
  if (summary.availableCases === 0) return 'OUT OF STOCK';
  if (summary.belowMinimum) return 'CRITICAL';
  if (summary.belowThreshold) return 'LOW';
  return 'GOOD';
};
